import { partApi } from './model/usersApi';

export type ConstantsType = {
  'SalesPoint.Tier': {
    TOP: number;
    MIDDLE: number;
    LOW: number;
  };
  'SalesPoint.Status': {
    ACTIVE: number;
    BLOCKED: number;
  };
  'SalesPoint.Direction': {
    KAM: number;
    DS: number;
    OP: number;
  };
};
const getConstantsApi = partApi.injectEndpoints({
  endpoints: (builder) => ({
    getConstants: builder.query<ConstantsType, any>({
      query: () => '/sales-point/admin/sales-point/constants/',
    }),
  }),
});

export const { useGetConstantsQuery } = getConstantsApi;
